export const BACKEND_RESOURCE_TIMING_INITIATOR_TYPES: ReadonlySet<string> = new Set([
	'fetch',
	'xmlhttprequest',
]);
